import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import PostJob from './pages/PostJob';
import Candidates from './pages/Candidates';
import CandidateDetail from './pages/CandidateDetail';
import MyProfile from './pages/MyProfile';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Register from './pages/Register';
import MyJobs from './pages/MyJobs';
import MyFavorites from './pages/MyFavorites';
import Experts from './pages/Experts';
import ExpertDetail from './pages/ExpertDetail';
import Messages from './pages/Messages';
import Feedback from './pages/Feedback';
import AdminImport from './pages/AdminImport';
import AdminPending from './pages/AdminPending';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/:id" element={<JobDetail />} />
              <Route path="/post-job" element={<PostJob />} />
              <Route path="/candidates" element={<Candidates />} />
              <Route path="/candidates/:id" element={<CandidateDetail />} />
              <Route path="/my-profile" element={<MyProfile />} />
              <Route path="/my-jobs" element={<MyJobs />} />
              <Route path="/my-favorites" element={<MyFavorites />} />
              <Route path="/experts" element={<Experts />} />
              <Route path="/experts/:id" element={<ExpertDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/register" element={<Register />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/admin" element={<AdminImport />} />
              <Route path="/admin/pending" element={<AdminPending />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <footer className="footer">
            <div className="container">
              <p>
                &copy; 2026 RollSleeves.com · 撸起袖子，连接全球机会
                {' · '}<a href="/terms" style={{ color: 'var(--text-light)', textDecoration: 'underline' }}>用户协议</a>
                {' · '}<a href="/privacy" style={{ color: 'var(--text-light)', textDecoration: 'underline' }}>隐私政策</a>
                {' · '}<a href="/feedback" style={{ color: 'var(--text-light)', textDecoration: 'underline' }}>联系我们</a>
              </p>
            </div>
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
